import { StyledDirectionalityOptionLabel } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/ContributionByCampaigns.style';
import { ALL_MOVEMENT } from 'modules/intelligentInsights/brandAffinityInsights/constants';
import { DirectionalityLegend } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/DirectionalityLegend';
import { BrandAffinityLevel } from 'modules/domains';
import {
  DirectionEnum,
  DirectionalityFilterEnum,
  CampaignWithDirectionality,
  ContributionCampaign,
  CalculatedTopCampaign,
} from 'modules/intelligentInsights/brandAffinityInsights/types';

export const getDirectionalitySelectDropdownOptions = (cohort: BrandAffinityLevel) => {
  return [
    {
      label: <StyledDirectionalityOptionLabel>{ALL_MOVEMENT}</StyledDirectionalityOptionLabel>,
      value: DirectionalityFilterEnum.ALLMOVEMENT,
    },
    {
      label: <DirectionalityLegend cohort={cohort} directionality={DirectionEnum.up} />,
      value: DirectionalityFilterEnum.UP,
    },
    {
      label: <DirectionalityLegend cohort={cohort} directionality={DirectionEnum.down} />,
      value: DirectionalityFilterEnum.DOWN,
    },
  ];
};

export const mergeCampaignData = (
  contributingCampaigns: ContributionCampaign[],
  campaignImpactList: CalculatedTopCampaign[],
) => {
  const mergedDataWithDirectionality = campaignImpactList
    .map((campaignTopItem) => {
      const campaign = contributingCampaigns.find((c) => c.id === campaignTopItem.campaignId);
      if (campaign) {
        return {
          ...campaign,
          direction: campaignTopItem.direction,
        };
      } else {
        return null;
      }
    })
    .filter(Boolean);
  return mergedDataWithDirectionality as CampaignWithDirectionality[];
};

export const filterByDirectionality = (
  campaignsWithDirectionality: CampaignWithDirectionality[],
  direction: DirectionalityFilterEnum.UP | DirectionalityFilterEnum.DOWN,
) => {
  return campaignsWithDirectionality
    .filter((campaignDataFromAPI) => {
      const asDirectionEnum = DirectionEnum[direction];
      if (campaignDataFromAPI.direction === asDirectionEnum) {
        return campaignDataFromAPI;
      } else {
        return null;
      }
    })
    .filter(Boolean);
};
